import { render } from "./ResourcesSection.vue?vue&type=template&id=81628eee&scoped=true"
const script = {}

import "./ResourcesSection.vue?vue&type=style&index=0&id=81628eee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81628eee"]])

export default __exports__